<template>
    <div>
        <models-base-form
            :creating="creating"
            :newObject="newObject"
            :editObject="campoExtra"
            :service="service"
            @created="onCreated($event)"
            @updated="onUpdated($event)"
        >
            <template v-slot:form="{ object }">
                <v-text-field v-model="object.campoExtra" label="Título"></v-text-field>
                <div v-if="showCkeditor">
                    Contenido
                    <ckeditor :editor="editor" v-model="object.contenido" :config="editorConfig"></ckeditor>
                </div>
            </template>
        </models-base-form>
    </div>
</template>

<script>
import { CampoExtraService } from "../../../services/carreras-api.service"
import { UploadAdapterPlugin } from "@/utils/upload-adapter-plugin"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

export default {
    data() {
        return {
            editor: ClassicEditor,
            editorConfig: {
                extraPlugins: [UploadAdapterPlugin]
            },
            service: CampoExtraService,
            newObject: {
                campoExtra: "",
                contenido: "",
                carreraSedeCampoExtra: {
                    carreraSedeId: this.carreraSedeId
                }
            },
            showCkeditor: false
        }
    },
    props: ["creating", "campoExtra", "carreraSedeId", "campoExtraDialog"],
    methods: {
        onCreated(campoExtra) {
            this.$emit("created", campoExtra)
        },
        onUpdated(campoExtra) {
            this.$emit("updated", campoExtra)
        }
    },
    watch: {
        campoExtraDialog() {
            setTimeout(() => {
                this.showCkeditor = this.campoExtraDialog
            }, 200)
        }
    },
    created() {
        setTimeout(() => {
            this.showCkeditor = this.campoExtraDialog
        }, 200)
    }
}
</script>
